export default __webpack_public_path__ + "static/media/Reforma.64aa176b.jpg";